import React, { useState } from "react";
import { Phone, MessageCircle, FileText, X } from "lucide-react";
import { CONTACT } from "../data/site";

export const FloatingButtons = () => {
  const [open, setOpen] = useState(true);
  const scrollToQuote = () => document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="fixed z-40 bottom-5 right-5 flex flex-col items-end gap-3">
      {open && (
        <>
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            data-testid="float-call"
            className="h-12 w-12 rounded-full bg-ink-700/90 backdrop-blur-xl border border-line flex items-center justify-center text-white hover:bg-orange hover:border-orange transition-colors shadow-[0_8px_32px_rgba(0,0,0,0.5)]"
            aria-label="Call us"
          >
            <Phone size={20} />
          </a>
          <a
            href="https://m.me/aussigns"
            target="_blank"
            rel="noreferrer"
            data-testid="float-messenger"
            className="h-12 w-12 rounded-full bg-ink-700/90 backdrop-blur-xl border border-line flex items-center justify-center text-white hover:bg-orange hover:border-orange transition-colors shadow-[0_8px_32px_rgba(0,0,0,0.5)]"
            aria-label="Message us"
          >
            <MessageCircle size={20} />
          </a>
        </>
      )}
      <button
        data-testid="float-quote"
        onClick={scrollToQuote}
        className="group flex items-center gap-2 rounded-full bg-orange hover:bg-orange-hover text-white font-head font-bold uppercase tracking-wide text-sm pl-4 pr-5 py-3 shadow-[0_8px_32px_rgba(255,95,21,0.4)] transition-colors"
      >
        <FileText size={18} /> Get a Quote
      </button>
    </div>
  );
};
